export default "__VITE_ASSET__BQuI0BLe__"